export const PASSWORD_WITH_STRENGTH_CHANGED = 'password.with.strength.changed';

export interface IPasswordWithStrengthEvent {
    password: string;
}
export type ServicePasswordStrengthEvents = {
    [PASSWORD_WITH_STRENGTH_CHANGED]: IPasswordWithStrengthEvent;
};
